var map = {
	"./imagem1.svg": "b4e7",
	"./imagem10.svg": "cfc2",
	"./imagem11.svg": "1ed6",
	"./imagem12.svg": "3971",
	"./imagem2.svg": "374b",
	"./imagem3.svg": "17f1",
	"./imagem4.svg": "04ba",
	"./imagem5.svg": "e0cd",
	"./imagem6.svg": "5f59",
	"./imagem7.svg": "fec7",
	"./imagem8.svg": "97ec",
	"./imagem9.svg": "ef42"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c9c8";